import { Fragment } from 'react';

import { Button } from '../../../../GlobalComponents/Button';
import { ButtonContainer } from './Card';

const CardActions = ({
	isRemoveCardLoading = false,
	showRemoveCard,
	showAddBalance,
	disableRemoveCard,
	toggleHandler,
	removeCardHandler
}: CardActionsProps): JSX.Element => {
	return (
		<Fragment>
			{(showRemoveCard || showAddBalance) && (
				<ButtonContainer>
					{showAddBalance && (
						<Button
							type="button"
							// backgroundColor="#F47920"
							disabled={isRemoveCardLoading}
							onClick={toggleHandler}
							$buttonSize={'small'}
						>
							ADD BALANCE
						</Button>
					)}
					{showRemoveCard && (
						<Button
							type="button"
							$backgroundColor="#DC3545"
							onClick={removeCardHandler}
							disabled={isRemoveCardLoading || disableRemoveCard}
							$isLoading={isRemoveCardLoading}
							$buttonSize={'small'}
						>
							REMOVE CARD
						</Button>
					)}
				</ButtonContainer>
			)}
		</Fragment>
	);
};

export default CardActions;

interface CardActionsProps {
	isRemoveCardLoading?: boolean;
	showRemoveCard: boolean;
	showAddBalance: boolean;
	disableRemoveCard: boolean;
	toggleHandler?: () => void;
	removeCardHandler?: () => void;
}
